import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import { Control, Controller } from 'react-hook-form';
import commonApi from 'apis/common';
import { uniqBy } from 'lodash-es';
import { Image } from 'antd';
import { Plus, X } from 'lucide-react';

const StoreReceiptPicsUploader = ({
  control,
  index,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
}) => {
  return (
    <Controller
      name={`productList.${index}.storeReceiptPics`}
      control={control}
      render={({ field }) => {
        const currentValue = field.value || [];

        return (
          <div className="flex gap-4 flex-wrap">
            {currentValue.length > 0 && (
              <Image.PreviewGroup>
                {currentValue.map((url) => (
                  <div className="w-28 h-28 relative" key={url}>
                    <Image
                      src={url}
                      alt=""
                      className="w-28 h-28 object-cover rounded"
                    />
                    <div
                      className="flex items-center justify-center absolute top-0 right-0 bg-red-500 text-white rounded-full p-1 cursor-pointer"
                      onClick={() =>
                        field.onChange(currentValue.filter((d) => d !== url))
                      }
                    >
                      <X className="w-4 h-4" />
                    </div>
                  </div>
                ))}
              </Image.PreviewGroup>
            )}

            <label className="relative flex justify-center items-center w-28 h-28 border border-dashed rounded cursor-pointer border-gray-400 hover:border-gray-500 hover:border-2">
              <Plus className="w-6 h-6 text-gray-400" />
              <input
                type="file"
                className="absolute opacity-0 pointer-events-none"
                multiple
                accept="image/jpeg, image/png, image/jpg, image/webp"
                onChange={async (e) => {
                  const files = Array.from(e.target.files || []);
                  if (!files.length) return;
                  const uploadPromises = files.map((file) =>
                    commonApi.uploadFile(file)
                  );
                  const results = await Promise.all(uploadPromises);
                  const uniqueList = uniqBy(
                    [...currentValue, ...results.map((result) => result.url)],
                    (d) => d
                  );
                  field.onChange(uniqueList);

                  // 清空 input 值，允许重复选择同一文件
                  e.target.value = '';
                }}
              />
            </label>
          </div>
        );
      }}
    />
  );
};

export default StoreReceiptPicsUploader;
